import React from "react";
import styled from "styled-components";

const FormTextarea = ({ children, ...props }) => {
  return (
    <Textarea {...props} />
  );
};

const Textarea = styled.textarea`
  border: 1px solid var(--aia-bx-gray-5);
  border-radius: 8px;
  padding: 11px 16px;
  width: 100%;
  outline-color: var(--aia-bx-blue-2);
  &:hover, &:focus {
    border-color: var(--aia-bx-blue-2);
    box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
  }
`;

export default FormTextarea;